/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
    FETCH_USER_DASHBOARDS,
FETCH_USER_DASHBOARDS_SUCCESS,
FETCH_USER_DASHBOARDS_FAILURE,

FETCH_USER_DASHBOARD,
FETCH_USER_DASHBOARD_SUCCESS,
FETCH_USER_DASHBOARD_FAILURE,


CREATE_USER_DASHBOARDS,
CREATE_USER_DASHBOARDS_SUCCESS,
CREATE_USER_DASHBOARDS_FAILURE,


UPDATE_USER_DASHBOARDS,
UPDATE_USER_DASHBOARDS_SUCCESS,
UPDATE_USER_DASHBOARDS_FAILURE,

DELETE_USER_DASHBOARDS,
DELETE_USER_DASHBOARDS_SUCCESS,
DELETE_USER_DASHBOARDS_FAILURE,

RESET_USER_DASHBOARD_STORE
  } from "./actionTypes";
  
  const INIT_STATE= {   
      
     
    userDashboardsListGetStatus:{isFetching: false,status: 'none',userdashboards: {items:[],totalCount:0},},
    userDashboardsGetStatus:{isFetching: false,didInvalidate: false,userdashboard: {},},
    
    userDashboardDeleteStatus:{status:'none',userdashboardId:0,dashboardname:''},
  
    userDashboardCreateStatus:{status:'none',userdashboard:{},dashboardname:''},
    userDashboardUpdateStatus:{status:'none',userdashboard:{},dashboardname:''},
  
  
  };
  const userdashboard = (
    state =INIT_STATE,
    action
  ) => {
    switch (action.type) {
      case RESET_USER_DASHBOARD_STORE:
        state=INIT_STATE;
      case FETCH_USER_DASHBOARDS:
        let userdashboardList=state.userDashboardsListGetStatus.userdashboards;
          return Object.assign({}, state, {
            userDashboardsListGetStatus:{isFetching: true,
          didInvalidate: false,
          userdashboards:userdashboardList,
          status:'inprogress'
          }});
      case FETCH_USER_DASHBOARDS_SUCCESS:
        return Object.assign({}, state, {
            userDashboardsListGetStatus:{isFetching: false,
                didInvalidate: false,
                userdashboards: action.userdashboards,
          status:'success'
        }});
      case FETCH_USER_DASHBOARDS_FAILURE:
        return {
          ...state,
          userDashboardsListGetStatus:{isFetching: false,
          didInvalidate: true,
          userdashboards: [],
        status:'failure'}
        };
        case FETCH_USER_DASHBOARD:
          return Object.assign({}, state, {
            userDashboardsGetStatus:{status:'inprogress',
            jobId: action.id,
            userdashboard:{},
          }});
        case FETCH_USER_DASHBOARD_SUCCESS:
          return Object.assign({}, state, {
            userDashboardsGetStatus:{status:'success',
            userdashboard:action.userdashboard,
          }});
        case FETCH_USER_DASHBOARD_FAILURE:
          return {
            ...state,
            userDashboardsGetStatus:{status:'failure',
            userdashboard:{},
          }};
         
          case CREATE_USER_DASHBOARDS:
            return Object.assign({}, state, {
              userDashboardCreateStatus:{status:'inprogress',userdashboard:{}},
            });
          case CREATE_USER_DASHBOARDS_SUCCESS:
            return Object.assign({}, state, {
              userDashboardCreateStatus:{status:'success',userdashboard:action.userdashboard,dashboardname:action.dashboardname},
         
            });
          case CREATE_USER_DASHBOARDS_FAILURE:
            return {
              ...state,
              userDashboardCreateStatus:{status:'failure',userdashboard:{},dashboardname:action.dashboardname},
         
            };
            case UPDATE_USER_DASHBOARDS:
              return Object.assign({}, state, {
                userDashboardUpdateStatus:{status:'inprogress',userdashboard:{},dashboardname:action.dashboardname},
              });
            case UPDATE_USER_DASHBOARDS_SUCCESS:
              return Object.assign({}, state, {
                userDashboardUpdateStatus:{status:'success',userdashboard:action.userdashboard,dashboardname:action.dashboardname},
           
              });
            case UPDATE_USER_DASHBOARDS_FAILURE:
              return {
                ...state,
                userDashboardUpdateStatus:{status:'failure',userdashboard:{},dashboardname:action.dashboardname},
           
              };

          case DELETE_USER_DASHBOARDS:
            return Object.assign({}, state, {
              userDashboardDeleteStatus:{status:'inprogress',dashboardname:action.dashboardname},
              
            });
          case DELETE_USER_DASHBOARDS_SUCCESS:
            return Object.assign({}, state, {
                userDashboardDeleteStatus:{status:'success', id:action.id,dashboardname:action.dashboardname},
            });
          case DELETE_USER_DASHBOARDS_FAILURE:
            return {
              ...state,
              userDashboardDeleteStatus:{status:'failure',dashboardname:action.dashboardname},
         
            };      
      default:
        return state;
    }
  };
  export default userdashboard;
  